import { DirectoryUsersDto, DirectoryResultDto, DirectoryResultCode }
	from "UvExplorerServer.Dtos.TS/Auth";


export class GetDirectoryUsersResultDto extends DirectoryResultDto {

	public Users: DirectoryUsersDto;

	constructor(code: DirectoryResultCode = DirectoryResultCode.None) {
		super(code);

		this.Users = new DirectoryUsersDto();
	}

	public get HasUsers(): boolean {
		return this.Users.HasUsers;
	}

	public Write(obj: any, context: any): void {
		obj.get_directory_users_result = {};
		obj = obj.get_directory_users_result;

		super.Write(obj, context);

		if (this.HasUsers) {
			this.Users.Write(obj, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.get_directory_users_result)
			throw new Error();
		obj = obj.get_directory_users_result;

		super.Read(obj, context);

		if (obj.directory_users !== undefined) {
			this.Users.Read(obj, context);
		}
	}

}